import React from 'react';
import BrandArrow from '../../Components/ui/BrandArrow';
import { getSiteAsset, useSiteAssets } from '../../utils/useSiteAssets';
import { FALLBACK_HERO } from '../../config/siteAssets';
import './HeroSection.css';


function HeroSection() {
  const assets = useSiteAssets();
  const heroUrl = getSiteAsset(assets, 'hero.main');
  const heroAlt = assets['hero.main']?.alt || 'Foto principal';
  const soleUrl = getSiteAsset(assets, 'hero.sole');
  const soleAlt = assets['hero.sole']?.alt || 'Foto de Sole Costilla';

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <>
      {/* ── HERO ── */}
      <section className="hero">
        {/* glow de fondo magenta (lado derecho) */}
        <div className="hero__glow" aria-hidden="true" />

        {/* ruido de textura */}
        <div className="hero__noise" aria-hidden="true" />

        <div className="hero__inner">
          {/* COLUMNA IZQUIERDA — foto hero */}
          <div className="hero__photo-col">
            <img src={heroUrl || FALLBACK_HERO} alt={heroAlt} className="hero__photo" />
            <div className="hero__photo-col2"></div>
          </div>
          {/* COLUMNA DERECHA — contenido */}
          <div className="hero__content-col">
            <h1 className="hero__title" data-aos="fade-up" data-aos-delay="100">
              Animáte a vivir una experiencia que va más allá de la foto
            </h1>

            <p className="hero__subtitle" data-aos="fade-up" data-aos-delay="220">
              Te doy la bienvenida a este espacio ¡vamos hacer realidad lo que
              más querés!
            </p>

            <div className="hero__buttons" data-aos="fade-up" data-aos-delay="360">
              {/* Botón primario (relleno magenta) con ícono flecha */}
             <button
  onClick={() => scrollToSection('servicios')}
  className="hero__btn hero__btn--primary"
>
  <span>TU SESIÓN DE FOTOS CREATIVA</span>
  <span className="hero__btn-arrow" aria-hidden="true">
<BrandArrow />
  </span>
</button>
              <button
                onClick={() => scrollToSection('trabajo')}
                className="hero__btn hero__btn--outline"
              >
                La cobertura de tu fiesta inolvidable
                <span className="hero__btn-arrow" aria-hidden="true">
                  <BrandArrow />
                </span>
              </button>

              <button
                onClick={() => scrollToSection('cta-banner')}
                className="hero__btn hero__btn--outline"
              >
                El diseño de tu evento soñado
                <span className="hero__btn-arrow" aria-hidden="true">
                  <BrandArrow />
                </span>
              </button>
            </div>
          </div>
        </div>

        {/* ticker inferior */}
        {/* <div className="hero__ticker" aria-hidden="true">
          <div className="hero__ticker-track">
            {[...Array(6)].map((_, i) => (
              <span key={i}>
                FOTOGRAFÍA &nbsp;✦&nbsp; EVENTOS &nbsp;✦&nbsp; SESIONES &nbsp;✦&nbsp;
                QUINCE AÑOS &nbsp;✦&nbsp; BODAS &nbsp;✦&nbsp; ESTUDIO &nbsp;✦&nbsp;
              </span>
            ))}
          </div>
        </div> */}
      </section>

     {/* ── SC GROUP INTRO ── */}
<section className="scg" id="sobre-sole">
  <div className="scg__inner">
    {/* encabezado */}
    <div className="scg__header" data-aos="fade-up">
      <span className="scg__tag">¡Hola! Soy Sole Costilla</span>
      <h2 className="scg__title">
        La artista creadora y fundadora de SC GROUP
      </h2>
    </div>

    <div className="scg__content" data-aos="fade-up" data-aos-delay="100">
      <img
        src={soleUrl || FALLBACK_HERO}
        alt={soleAlt}
        className="scg__photo"
      />

      <div className="scg__text">
        <p className="scg__lead scg__lead--bold" data-aos="fade-up" data-aos-delay="100">
          Mi deseo es que este sea tu espacio de encuentro con vos mismo.
        </p>

        <p className="scg__lead" data-aos="fade-up" data-aos-delay="200">
          Si estás planificando tus 15 años, tu boda, celebrar a la persona que amas,
          una sesión creativa, el evento de tu empresa y quieres que seamos parte,
          la decisión está en ti y yo estoy aquí para acompañarte, con confianza y
          profesionalismo junto a mi equipo.
        </p>
      </div>
    </div>
  </div>

  {/* línea magenta inferior */}
  <div className="scg__bottom-line" aria-hidden="true" />
</section>
    </>
  );
}

export default HeroSection;